import { Component, inject } from '@angular/core';
import { HeaderService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  HeaderCreateDto,
  HeaderDto,
  HeaderExcelDownloadDto,
  HeaderUpdateDto,
} from '../proxy/general/dtos/header';
import { HEADER_CONFIG, HEADER_FIELDS } from './header.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-header',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, HeaderService, ConfirmationService],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header extends BaseCrudComponent<
  HeaderDto,
  HeaderCreateDto,
  HeaderUpdateDto,
  HeaderExcelDownloadDto
> {
  service = inject(HeaderService);
  config = HEADER_CONFIG;
  fields = HEADER_FIELDS;

  protected prepareUpdateDto(data: any, selected: HeaderDto): HeaderUpdateDto {
    return {
      name: data.name,
      brandId: data.brandId,
      modelId: data.modelId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Header';
  }
}
